/**
 * values for 'responsive' sizing
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';

const RESPONSIVE_SIZES = {
  EXTRA_SMALL: 'extrasmall',
  SMALL:       'small',
  MEDIUM:      'medium',
  STANDARD:    'standard',
  LARGE:       'large',
  EXTRA_LARGE: 'extralarge',
};

//extracompact, compact, half width, standard, large, full width

const RESPONSIVE_SIZE_LIST = [
  { label: locale('Extra compact'), submitValue: RESPONSIVE_SIZES.EXTRA_SMALL, percent: '25%' },
  { label: locale('Compact'), submitValue: RESPONSIVE_SIZES.SMALL, percent: '40%' },
  { label: locale('Medium'), submitValue: RESPONSIVE_SIZES.MEDIUM, percent: '50%' },
  { label: locale('Large'), submitValue: RESPONSIVE_SIZES.LARGE, percent: '75%' },
  { label: locale('Max'), submitValue: RESPONSIVE_SIZES.EXTRA_LARGE, percent: '100%' },
];

const RESPONSIVE_SIZES_ALL = _.values(RESPONSIVE_SIZES, 'value');

const getSizeIndex = responsiveSize => {
  return _.findIndex(RESPONSIVE_SIZE_LIST, function(r) {
    return r.submitValue === responsiveSize;
  });
};

const getSizeInfo = (responsiveSize, defaultIdx) => {
  let idx = getSizeIndex(responsiveSize);
  if (idx < 0 && defaultIdx != undefined) idx = defaultIdx;
  if (idx > -1 && idx < RESPONSIVE_SIZE_LIST.length) {
    return RESPONSIVE_SIZE_LIST[idx];
  }
  return null;
};

export { RESPONSIVE_SIZES, RESPONSIVE_SIZE_LIST, RESPONSIVE_SIZES_ALL, getSizeInfo, getSizeIndex };

export default RESPONSIVE_SIZES;
